import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-for-workshops24',
  templateUrl: './call-for-workshops.component.html',
  styleUrls: ['./call-for-workshops.component.css']
})
export class CallForWorkshopsComponent24 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
